import { state, props, string } from 'cerebral/tags'
import { set, when, merge } from 'cerebral/operators'
import setTagsForm from './setTagsForm'
import loadDetails from '../actions/loadDetails'

export default [
  set(props`selectedFiles`, state`media.selectedFiles`),
  function({ props }) {
    const nextIndex =
      props.nextIndex + 1 > props.selectedFiles.length
        ? 0
        : props.nextIndex < 0 ? props.selectedFiles.length - 1 : props.nextIndex

    return {
      id: props.selectedFiles[nextIndex]
    }
  },
  set(state`media.currentFile`, string`media.files.${props`id`}`),
  when(state`media.files.${props`id`}.groups`), // if we have groups the media detail is loaded
  {
    true: [],
    false: [
      set(state`media.tags.isLoading`, true),
      loadDetails,
      {
        loaded: [
          merge(state`media.files.${props`id`}`, props`payload`),
          set(state`media.tags.isLoading`, false)
        ],
        error: []
      }
    ]
  },
  ...setTagsForm
]



// WEBPACK FOOTER //
// ./src/modules/Media/chains/setCurrentDetailedFile.js